export default "__VITE_ASSET__MKVz7wqz__"